import { Injectable } from '@angular/core';
import { Observable, of, throwError } from 'rxjs';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { catchError, tap, map } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { Service } from './service.interface';
import { User } from '../entities/user';

@Injectable({
  providedIn: 'root'
})
export class UserService extends Service  {

  constructor(private http: HttpClient  ) {
    super(http, environment.baseURLsage  + 'users');
   }
   private handleError<T>(operators = 'operation',  result?: T) {
     return (error: any): Observable<T> => {
       // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead

      // Let the app keep running by returning an empty result.
      return of(result as T);
     };
   }

   getUser(id): Observable<User>  {
     const url = `${this.baseURL}/${id}`;
     return this.get<User>(url).pipe(
       catchError(this.handleError<User>('getUser id = ' + id))
     );
   }

   addUser(user): Observable<User> {
    return this.post<User>(this.baseURL, user).pipe(
      catchError(this.handleError<User>('addUser'))
    );
  }

  updateUser(id, user): Observable<any> {
    const url = `${this.baseURL}/${id}`;
    return this.patch(url, user).pipe(
      catchError(this.handleError<any>('updateUser'))
    );
  }

  updatePassword(id, user): Observable<any> {
    const url = `${this.baseURL}/${id}`;
    user.password = user.nuevapassword;
    return this.patch(url, user).pipe(
      catchError(this.handleError<any>('updateUser'))
    );
  }

  deleteUser(id): Observable<User> {
    const url = `${this.baseURL}/${id}`;
    return this.delete<User>(url).pipe(
      catchError(this.handleError<User>('deleteUser'))
    );
  }
}
